<influencer-module-container [title]="title" 
	[useAbsolutePositionHeader]="true"
	[hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
	[placeholderWidth]="361" 
	[height]="'335px'">
	
	<div class="chart-area">
		<achoo-line-chart *ngIf="!hasNoData && !isFetchingData"
			[chartData]="drawnData"
			[legendItemDistance]="22"
			[legendYPosition]="5"
			[legendXPosition]="8"
			[legendMargin] = "30"
			[spacingBottom]="30"
			[spacingRight]="0"
			[height]="335"
			[useDefaultPlaceholder]="false"
			[backgroundColor]="'transparent'"
			[areaFillColor]="areaFillColor"
			[overridenTooltipConfig]="overridenTooltipConfig">
		</achoo-line-chart>

		<achoo-line-chart *ngIf="hasNoData || isFetchingData"
			[chartData]="placeholderData"
			[legendItemDistance]="22"
			[legendYPosition]="5"
			[legendXPosition]="8"
			[legendMargin] = "30"
			[spacingBottom]="30"
			[spacingRight]="0"
			[height]="335"
			[useDefaultPlaceholder]="false"
			[backgroundColor]="'transparent'">
		</achoo-line-chart>
	</div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/performance-timeline/performance-timeline.component.html